import { createContext } from 'react'

const forms = createContext()

export default forms